module.exports = __webpack_public_path__ + "img/years.f1afad53.png";